const playerCreateBreadcrumb = (data) => {
  const { teamName } = data || {}

  return [teamName ? teamName.toUpperCase() : '', 'PLAYER MANAGEMENT', 'CREATE']
}

export default playerCreateBreadcrumb
